var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    "data-original": "#000000",
    fill: "#000000",
    d: "m31,54.75l2,0c0.551,0 1,0.448 1,1l2,0c0,-1.654 -1.346,-3 -3,-3l-2,0c-1.654,0 -3,1.346 -3,3s1.346,3 3,3l2,0c0.551,0 1,0.448 1,1s-0.449,1 -1,1l-2,0c-0.551,0 -1,-0.448 -1,-1l-2,0c0,1.654 1.346,3 3,3l2,0c1.654,0 3,-1.346 3,-3s-1.346,-3 -3,-3l-2,0c-0.551,0 -1,-0.448 -1,-1s0.449,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    "data-original": "#000000",
    fill: "#000000",
    d: "m63,28.75l0,-2l-6,0l0,10l6,0l0,-2l-4,0l0,-2l4,0l0,-2l-4,0l0,-2l4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    "data-original": "#000000",
    fill: "#000000",
    d: "m9.895,37.75l1.099,-9.89l-1.988,-0.22l-0.646,5.812l-0.54,-2.702l-3.64,0l-0.54,2.702l-0.646,-5.812l-1.988,0.22l1.099,9.89l2.715,0l1,-5l0.36,0l1,5l2.715,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    "data-original": "#000000",
    fill: "#000000",
    d: "m30,3.986l3.382,6.764l2.618,0l0,-10l-2,0l0,6.764l-3.382,-6.764l-2.618,0l0,10l2,0l0,-6.764z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    "data-original": "#000000",
    fill: "#000000",
    d: "m32,27.75c-2.206,0 -4,1.794 -4,4s1.794,4 4,4s4,-1.794 4,-4s-1.794,-4 -4,-4zm0,6c-1.103,0 -2,-0.897 -2,-2s0.897,-2 2,-2s2,0.897 2,2s-0.897,2 -2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    "data-original": "#000000",
    fill: "#000000",
    d: "m48.828,29.541c-0.991,-7.653 -6.967,-13.628 -14.619,-14.619l-0.059,-0.351c-0.176,-1.055 -1.08,-1.821 -2.15,-1.821s-1.974,0.766 -2.151,1.822l-0.058,0.35c-7.652,0.99 -13.628,6.965 -14.619,14.619l-0.349,0.058c-1.057,0.176 -1.823,1.081 -1.823,2.151s0.766,1.975 1.822,2.15l0.35,0.058c0.991,7.653 6.967,13.628 14.619,14.619l0.059,0.351c0.176,1.056 1.08,1.822 2.15,1.822s1.974,-0.766 2.151,-1.822l0.058,-0.35c7.652,-0.99 13.628,-6.965 14.619,-14.619l0.349,-0.058c1.057,-0.176 1.823,-1.081 1.823,-2.151s-0.766,-1.975 -1.822,-2.15l-0.35,-0.059zm-2.058,-0.343l-6.673,-1.112l2.55,-6.911c2.119,2.134 3.593,4.908 4.123,8.023zm-4.195,-8.095l-6.911,2.549l-1.112,-6.672c3.115,0.53 5.89,2.004 8.023,4.123zm-4.19,5.847c-0.452,-0.6 -0.985,-1.133 -1.585,-1.585l2.511,-0.927l-0.926,2.512zm0.926,12.112l-2.511,-0.927c0.6,-0.452 1.133,-0.985 1.585,-1.585l0.926,2.512zm-7.489,-24.161c0.029,-0.176 0.327,-0.175 0.356,-0.001l1.505,9.031c-0.543,-0.116 -1.105,-0.181 -1.683,-0.181s-1.14,0.065 -1.683,0.182l1.505,-9.031zm-2.374,2.079l-1.112,6.672l-6.911,-2.549c2.133,-2.119 4.908,-3.593 8.023,-4.123zm-4.759,7.458l2.511,0.927c-0.6,0.452 -1.133,0.985 -1.585,1.585l-0.926,-2.512zm2.511,13.697l-2.511,0.927l0.926,-2.512c0.452,0.6 0.985,1.133 1.585,1.585zm-5.847,-16.96l2.55,6.911l-6.673,1.112c0.53,-3.115 2.004,-5.889 4.123,-8.023zm-6.203,10.753c-0.087,-0.015 -0.15,-0.089 -0.15,-0.178s0.063,-0.163 0.151,-0.178l9.031,-1.505c-0.117,0.543 -0.182,1.105 -0.182,1.683s0.065,1.14 0.182,1.683l-9.032,-1.505zm2.08,2.374l6.673,1.112l-2.55,6.911c-2.119,-2.134 -3.593,-4.908 -4.123,-8.023zm4.195,8.095l6.911,-2.549l1.112,6.672c-3.115,-0.53 -5.89,-2.004 -8.023,-4.123zm10.753,6.202c-0.029,0.176 -0.327,0.175 -0.356,0.001l-1.505,-9.031c0.543,0.116 1.105,0.181 1.683,0.181s1.14,-0.065 1.683,-0.182l-1.505,9.031zm-0.178,-10.849c-3.309,0 -6,-2.691 -6,-6s2.691,-6 6,-6s6,2.691 6,6s-2.691,6 -6,6zm2.552,8.77l1.112,-6.672l6.911,2.549c-2.133,2.119 -4.908,3.593 -8.023,4.123zm8.095,-4.195l-2.55,-6.911l6.673,-1.112c-0.53,3.115 -2.004,5.889 -4.123,8.023zm6.202,-10.397l-9.031,1.505c0.117,-0.543 0.182,-1.105 0.182,-1.683s-0.065,-1.14 -0.182,-1.683l9.031,1.505c0.088,0.015 0.151,0.089 0.151,0.178s-0.063,0.163 -0.151,0.178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    "data-original": "#000000",
    fill: "#000000",
    d: "m26.271,7.417l-0.457,-1.947c-9.887,2.319 -17.775,10.207 -20.094,20.094l1.947,0.457c2.147,-9.155 9.45,-16.458 18.604,-18.604z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    "data-original": "#000000",
    fill: "#000000",
    d: "m56.075,25.019l1.927,-0.537c-2.645,-9.481 -10.238,-16.766 -19.816,-19.012l-0.457,1.947c8.867,2.08 15.897,8.824 18.346,17.602z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    "data-original": "#000000",
    fill: "#000000",
    d: "m37.729,56.083l0.457,1.947c9.578,-2.246 17.171,-9.531 19.816,-19.012l-1.927,-0.537c-2.449,8.778 -9.479,15.522 -18.346,17.602z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    "data-original": "#000000",
    fill: "#000000",
    d: "m8.214,39.442l-1.903,0.615c2.889,8.942 10.363,15.83 19.504,17.973l0.457,-1.947c-8.463,-1.985 -15.383,-8.361 -18.058,-16.641z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.53d335f2eec2fd1dd5f02318b718b306.svg";
export { ForwardRef as ReactComponent };